import script from "./PageMain.vue?vue&type=script&setup=true&lang=js"
export * from "./PageMain.vue?vue&type=script&setup=true&lang=js"

import "./PageMain.vue?vue&type=style&index=0&id=177212c2&lang=css"

const __exports__ = script;

export default __exports__